import React, { ReactElement, useRef, useState, useEffect } from 'react'
import { Input, Button, Space } from 'antd'
import type { InputRef } from 'antd'

const EditQuestion = (props: {
    messageId: number
    content: string
    // eslint-disable-next-line no-unused-vars
    reSend: (messageId: number, editContent: string) => void
    // eslint-disable-next-line no-unused-vars
    reSendCancel: (messageId: number) => void
    isAnswer?: boolean
}): ReactElement => {
    const textareaRef = useRef<InputRef>(null)
    const { messageId, content, reSend, reSendCancel, isAnswer } = props
    const { TextArea } = Input
    const [editContent, setEditContent] = useState('')

    const onReSend = () => {
        reSend(messageId, editContent)
    }
    const onCancel = () => {
        reSendCancel(messageId)
    }

    useEffect(() => {
        textareaRef.current?.focus()
        setEditContent(content)
    }, [])
    return (
        <div className='edit_box'>
            <TextArea value={editContent} ref={textareaRef} className='edit_textarea'
                autoSize={{
                    minRows: 2,
                }}
                onChange={(e: any) => {
                    setEditContent(e.target.value)
                }}
            ></TextArea>
            <div style={{ textAlign: 'right' }}>
                <Space>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button type='primary' onClick={onReSend}>{(isAnswer === undefined || !isAnswer) ? 'Send' : 'Save'}</Button>
                </Space>
            </div>
        </div>
    )
}

export default EditQuestion